var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaWeightHanging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3411_2304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3411_2304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33519 13.1667H12.3352L11.3852 6.5H5.28519L4.33519 13.1667ZM8.33519 5.16667C8.52408 5.16667 8.68242 5.10278 8.81019 4.975C8.93797 4.84722 9.00186 4.68889 9.00186 4.5C9.00186 4.31111 8.93797 4.15278 8.81019 4.025C8.68242 3.89722 8.52408 3.83333 8.33519 3.83333C8.1463 3.83333 7.98797 3.89722 7.86019 4.025C7.73242 4.15278 7.66853 4.31111 7.66853 4.5C7.66853 4.68889 7.73242 4.84722 7.86019 4.975C7.98797 5.10278 8.1463 5.16667 8.33519 5.16667ZM10.2185 5.16667H11.3852C11.7185 5.16667 12.0074 5.27778 12.2519 5.5C12.4963 5.72222 12.6463 5.99444 12.7019 6.31667L13.6519 12.9833C13.7074 13.3833 13.6046 13.7361 13.3435 14.0417C13.0824 14.3472 12.7463 14.5 12.3352 14.5H4.33519C3.92408 14.5 3.58797 14.3472 3.32686 14.0417C3.06575 13.7361 2.96297 13.3833 3.01853 12.9833L3.96853 6.31667C4.02408 5.99444 4.17408 5.72222 4.41853 5.5C4.66297 5.27778 4.95186 5.16667 5.28519 5.16667H6.45186C6.41853 5.05556 6.39075 4.94722 6.36853 4.84167C6.3463 4.73611 6.33519 4.62222 6.33519 4.5C6.33519 3.94444 6.52964 3.47222 6.91853 3.08333C7.30742 2.69444 7.77964 2.5 8.33519 2.5C8.89075 2.5 9.36297 2.69444 9.75186 3.08333C10.1407 3.47222 10.3352 3.94444 10.3352 4.5C10.3352 4.62222 10.3241 4.73611 10.3019 4.84167C10.2796 4.94722 10.2519 5.05556 10.2185 5.16667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaWeightHanging);
export default __webpack_public_path__ + "static/media/FaWeightHanging.879404e6f897f3ce93f81703b4bb1c97.svg";
export { ForwardRef as ReactComponent };